import { __assign } from 'tslib';
import { textInput } from './text-input.js';

var _a, _b;
var selectContainer = {
    base: __assign(__assign({}, textInput.base), { display: "grid", gridTemplateAreas: '"select"', alignItems: "center", position: "relative", "&::after": {
            gridArea: "select",
            justifySelf: "end",
            content: "url(\"data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24' fill='none' %3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M21.308 6.899l.222.204a1.448 1.448 0 010 2.135l-8.506 7.863a1.514 1.514 0 01-2.049 0L2.47 9.238a1.448 1.448 0 010-2.135l.22-.204a1.514 1.514 0 012.049 0l6.92 6.396a.505.505 0 00.682 0l6.92-6.396a1.514 1.514 0 012.047 0z' fill='%23808080' /%3E%3C/svg%3E\");",
            width: "16px",
            height: "16px",
            left: "-16px",
            position: "relative",
            color: "black.60",
        } }),
    variants: {
        invalid: __assign({}, (_a = textInput.variants) === null || _a === void 0 ? void 0 : _a.invalid),
        disabled: __assign({}, (_b = textInput.variants) === null || _b === void 0 ? void 0 : _b.disabled),
    },
};
var select = {
    base: {
        gridArea: "select",
        position: "relative",
        appearance: "none",
        backgroundColor: "transparent",
        border: "none",
        margin: 0,
        fontFamily: "inherit",
        fontSize: "inherit",
        cursor: "inherit",
        lineHeight: "inherit",
        width: "100%",
        height: "var(--select-input-height)",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        "&:focus": {
            outline: "none",
        },
    },
    variants: {
        size: {
            sm: {
                fontSize: 2,
                "--select-input-height": "31px",
                padding: "0 40px 0 16px",
            },
            md: {
                "--select-input-height": "42px",
                padding: "0 40px 0 16px",
            },
            lg: {
                "--select-input-height": "54px",
                padding: "0 40px 0 16px",
            },
        },
    },
};

export { select, selectContainer };
//# sourceMappingURL=select-input.js.map
